import React from "react";

const Footer = () => {
    return (
        <footer className="bg-pcc-black text-white text-center p-2 mt-auto">
            © 2025 Pasadena City College. All rights reserved.
        </footer>
    );
};

export default Footer;